export type CookieOptions = {
	days?: number
	domain?: 'all' | 'this'
	path?: string
	secure?: boolean
}

export type UnsetCookieOptions = Omit<CookieOptions, 'days'>

export default new class Cookies {
	#memoized: string
	#parsed: Record<string, string>

	public getAll(): Record<string, string> {
		if (this.#memoized !== document.cookie) {
			this.#memoized = document.cookie
			this.#parsed = Object.fromEntries(
				document.cookie
					.split(';')
					.map(entry => entry.trim().split('='))
					.filter(([key]) => !!key)
			)
		}
	
		return this.#parsed
	}

	public get(name: string): string {
		return this.getAll()[name]
	}

	public set(name: string, value: { toString(): string }, options: CookieOptions = {}): boolean {
		const {
			days = 30,
			domain = 'all',
			path = '/',
			secure = true
		} = options

		const entry = [
			`${name}=${value.toString()}`,
			days && 'Expires=' + new Date(Date.now() + 1000 * 60 * 60 * 24 * days).toUTCString(),
			path && `Path=${path}`,
			domain == 'all' && location.hostname != 'localhost' && `Domain=.${location.hostname}`,
			(domain == 'this' || location.hostname == 'localhost') && `Domain=${location.hostname}`,
			location.protocol == 'https:' && secure && 'Secure',
		].filter(c => c)
	
		document.cookie = entry.join('; ')

		return true
	}

	public unset(name: string, options: UnsetCookieOptions = {}): boolean {
		return this.set(name, '', {
			...options,
			days: -1
		})
	}
}